import { render, staticRenderFns } from "./SalesQuotes.vue?vue&type=template&id=614ad147"
import script from "./SalesQuotes.vue?vue&type=script&lang=js"
export * from "./SalesQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports